import { AcceptPublicOfferState } from './acceptPublicOffer.types'

const initialState: AcceptPublicOfferState = {
  loading: false,
  error: null,
  success: null
}

export default initialState
